<template>
    <div class="shield-dialog">
        <el-dialog :visible.sync="shieldModalVisible" width="592px" :before-close="resetForm" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" v-el-drag-dialog>
            <div slot="title" class="task-modal-title">
                <span class="modal-title-span">选择屏蔽原因</span>
            </div>
            <div class="">
                <el-form :model="ruleForm_shieldModal" :rules="rules" ref="ruleForm_shieldModal" label-width="100px" class="demo-ruleForm" @validate="validateTwo" :show-message="false">
                    <el-form-item label="屏蔽原因" prop="reason">
                        <el-select v-model="ruleForm_shieldModal.reason" placeholder="请选择">
                            <el-option
                                v-for="item in getReportReasonList"
                                :key="item.index"
                                :label="item.content"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="task-modal-footer">
                <el-button @click="resetForm('ruleForm_shieldModal')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm_shieldModal')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: 'shieldModal',
    props: {
        isOneBtn: {
            type: Boolean,
            default: false
        },
        shieldModalVisible: {
            type: Boolean,
            default: false
        },
        agreeBtn: {
            type: String,
            default: '确定'
        },
        //是否点击空白处关闭弹窗
        closeonclickmodal:{
            type:Boolean,
            default:false
        }
    },
    data () {
        return {
            ruleForm_shieldModal: {
                reason: '',
            },
            rules: {
                reason: [
                    { required: true, message: '请选择屏蔽原因', trigger: 'change' }
                ],
            },
            getReportReasonList: [],
            countNum: 1, // 只显示第一条错误信息
        }
    },
    created () {
        this.getReportReasonFuc()
    },
    methods: {
        ...mapActions([
            'getReportReason',
        ]),
        validateTwo(prop, msgStatus, validateMessage) {
            // console.log(prop, msgStatus, validateMessage)
            if (!msgStatus && !this.countNum) {
                this.countNum += 1;
                if (validateMessage) {
                    this.$message.error(validateMessage)
                }
            }
        },
        async getReportReasonFuc() {
            // console.log('12313231323')
            const {
                data: { result, msg, status }
            } = await this.getReportReason()
            if (status === 1000) {
                console.log(result)
                this.getReportReasonList = result
                return
            }
            this.$message.error(msg);
        },
        submitForm(formName) {
            this.countNum = 0;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('agreeToShield', this.ruleForm_shieldModal);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs['ruleForm_shieldModal'].resetFields();
            this.handleClose()
        },
        // 弹窗关闭触发
        handleClose() {
            this.$emit('cancelShieldModal', 'ruleForm_shieldModal');
        },
        // 确认
        agreeAdd() {
            // this.$emit('agreeToShield', 'ruleForm_shieldModal');
        },
        // 取消
        closeModal() {
            this.$emit('cancelShieldModal', 'ruleForm_shieldModal');
        }
    }
}
</script>

<style lang="scss">
.shield-dialog {
  .el-dialog__header {
    // border-bottom: 1px solid #D4D4D7;
    padding: 11px 16px;
    line-height: normal;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .task-modal-title {
      .modal-title-icon {
        font-size: 18px;
      }
      .modal-title-span {
        font-size: 18px;
        color: #2E4057;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    // height: 276px;
    padding: 16px;
    // text-align: center;
    // overflow-y: auto;
    font-size: 14px!important;
    .el-form-item {
      display: inline-block;
      margin-bottom: 8px;
    }
  }
  .el-dialog__footer {
    // border-top: 1px solid #D4D4D7;
    padding: 16px;
    line-height: normal;
    .task-modal-footer {
      font-size: 0;
      .el-button {
        // padding: 0 !important;
        margin-left: 8px !important;
      }
      .modal-footer-two {
        // width: 48px;
        height: 28px;
      }
      .modal-footer-four {
        // width: 72px;
        height: 28px;
      }
    }
  }
}
</style>
